
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'svg-loader',
  props: {
    width: {
      type: [Number, String],
      default: 18,
    },
    height: {
      type: [Number, String],
      default: 18,
    },
    iconColor: {
      type: String,
      default: 'currentColor',
    },
  },
});
